import React, { useState } from 'react';
import { Check, ShieldCheck, Flame, ArrowRight, Package, Clock, TrendingDown, BrainCog, AlertCircle, Star } from 'lucide-react';
import { PurchasePopup } from './components/PurchasePopup';
import { CountdownTimer } from './components/CountdownTimer';
export function App() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'completo' | 'cognitivas20' | 'cognitivas60' | 'demencia' | 'demencialeve' | 'todo'>('base');
  const checkoutUrlBase = 'https://terapeuticocheckout.ebookditales.com/cart/51857635672347:1';
  const checkoutUrlCompleto = 'https://terapeuticocheckout.ebookditales.com/cart/51868911468827:1';
  const checkoutUrlCognitivas20 = 'https://terapeuticocheckout.ebookditales.com/cart/51886382809371:1';
  const checkoutUrlCognitivas60 = 'https://terapeuticocheckout.ebookditales.com/cart/51886383726875:1';
  const checkoutUrlDemencia = 'https://terapeuticocheckout.ebookditales.com/cart/51886384415003:1';
  const checkoutUrlDemenciaLeve = 'https://terapeuticocheckout.ebookditales.com/cart/51886387364123:1';
  const checkoutUrlTodo = 'https://terapeuticocheckout.ebookditales.com/cart/51886391427355:1';
  const checkoutMap: Record<string, string> = {
    base: checkoutUrlBase,
    completo: checkoutUrlCompleto,
    cognitivas20: checkoutUrlCognitivas20,
    cognitivas60: checkoutUrlCognitivas60,
    demencia: checkoutUrlDemencia,
    demencialeve: checkoutUrlDemenciaLeve,
    todo: checkoutUrlTodo
  };
  const ctaTextMap: Record<string, string> = {
    base: 'SÍ, QUIERO EL MEGAPACK BASE →',
    completo: 'SÍ, QUIERO EL PACK COMPLETO →',
    cognitivas20: 'SÍ, QUIERO FICHAS COGNITIVAS 20-50 →',
    cognitivas60: 'SÍ, QUIERO FICHAS COGNITIVAS 60-90 →',
    demencia: 'SÍ, QUIERO FICHAS DEMENCIA MODERADA →',
    demencialeve: 'SÍ, QUIERO FICHAS DEMENCIA LEVE →',
    todo: 'SÍ, QUIERO EL PACK COMPLETO POR TODO →'
  };
  const detailsMap: Record<string, {
    title: string;
    items: string[];
  }> = {
    base: {
      title: 'MEGA PACK BASE INCLUYE:',
      items: ['24 sesiones completas paso a paso', 'Hojas de trabajo imprimibles', 'Protocolos clínicos y mini guías', 'Sistema de seguimiento terapéutico', 'Intervención TDAH (+120 fichas)', 'Intervención Dislexia (72 actividades)', 'Herramientas TCC aplicadas', '3 bonos profesionales incluidos']
    },
    completo: {
      title: 'PACK COMPLETO INCLUYE:',
      items: ['✅ Todo lo incluido en el Mega Pack Base', '50 actividades cognitivas para adolescentes (12-17 años)', 'Mega Pack Terapéutico completo', 'TDAH + Dislexia + TCC', 'Todos los bonos y materiales detallados']
    },
    cognitivas20: {
      title: 'FICHAS COGNITIVAS 20-50 AÑOS INCLUYE:',
      items: ['✅ Todo lo incluido en el Mega Pack Base', 'Fichas cognitivas para adultos de 20 a 50 años', 'Material de evaluación y seguimiento', 'Actividades estructuradas por área cognitiva', 'Todos los bonos del Mega Pack Base']
    },
    cognitivas60: {
      title: 'FICHAS EVALUACIÓN COGNITIVA 60-90 AÑOS INCLUYE:',
      items: ['✅ Todo lo incluido en el Mega Pack Base', 'Fichas de evaluación cognitiva para adultos mayores (60-90 años)', 'Protocolos de evaluación adaptados', 'Registro de progreso cognitivo', 'Todos los bonos del Mega Pack Base']
    },
    demencia: {
      title: 'FICHAS DEMENCIA MODERADA 60-90 AÑOS INCLUYE:',
      items: ['✅ Todo lo incluido en el Mega Pack Base', 'Fichas de intervención en demencia moderada (60-90 años)', 'Actividades de estimulación cognitiva', 'Protocolos de trabajo con familias', 'Todos los bonos del Mega Pack Base']
    },
    demencialeve: {
      title: 'FICHAS DEMENCIA LEVE 60-90 AÑOS INCLUYE:',
      items: ['✅ Todo lo incluido en el Mega Pack Base', 'Fichas cognitivas para demencia leve (60-90 años)', 'Actividades de estimulación y prevención', 'Seguimiento terapéutico especializado', 'Todos los bonos del Mega Pack Base']
    },
    todo: {
      title: 'PACK POR TODO INCLUYE:',
      items: ['✅ Mega Pack Base completo', '✅ Fichas cognitivas adolescentes (12-17 años)', '✅ Fichas cognitivas adultos (20-50 años)', '✅ Fichas evaluación cognitiva (60-90 años)', '✅ Fichas demencia moderada (60-90 años)', '✅ Fichas demencia leve (60-90 años)', 'TDAH + Dislexia + TCC completo', 'Todos los bonos profesionales']
    }
  };
  return <div className="min-h-screen bg-gradient-to-b from-sky-50 via-white to-gray-50 font-sans text-gray-900" data-id="element-0">
      <PurchasePopup data-id="element-1" />

      {/* Hero Section */}
      <header className="h-[100svh] md:h-auto md:py-16 px-3 py-2 bg-gradient-to-b from-sky-50 to-white flex flex-col md:block" data-id="element-2">
        <div className="max-w-3xl mx-auto text-center w-full flex flex-col h-full md:h-auto md:block" data-id="element-3">
          <div className="bg-sky-100 rounded-xl px-4 py-1.5 md:px-6 md:py-3 mb-1.5 md:mb-3 max-w-2xl mx-auto" data-id="element-4">
            <p className="text-[8px] md:text-sm text-sky-800 leading-snug text-center" data-id="element-5">
              Para psicólogas que sienten que trabajan mucho… pero siguen
              cansadas, inseguras y con ingresos que no crecen
            </p>
          </div>

          <h1 className="text-lg md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-1 md:mb-4 px-1" data-id="element-6">
            Cuando toda tu energía se va en preparar sesiones…
            <span className="text-sky-600" data-id="element-7"> tu práctica no puede crecer.</span>
          </h1>

          <p className="text-[9px] md:text-lg text-gray-800 font-medium mb-1 md:mb-2 max-w-2xl mx-auto px-1 leading-snug" data-id="element-8">
            Este sistema te da 24 sesiones terapéuticas listas para trabajar con
            orden y menos desgaste.
          </p>

          <p className="hidden md:block text-sm text-gray-500 italic mb-6 max-w-lg mx-auto" data-id="element-9">
            Sistema de trabajo clínico con material para 6 meses de sesiones.
          </p>

          <div className="flex-1 flex items-center justify-center md:flex-none md:mb-8 px-4" data-id="element-10">
            <img src="https://cdn.magicpatterns.com/uploads/nN1JABCQkXrmxo1zpTeGdv/image-removebg-preview.png" alt="Mega Pack Terapéutico" className="w-full max-w-[85vw] md:max-w-xl drop-shadow-2xl object-contain" data-id="element-11" />
          </div>

          <div className="mt-auto md:mt-0" data-id="element-12">
            <div className="max-w-2xl mx-auto grid grid-cols-2 gap-x-3 gap-y-0.5 md:gap-x-6 md:gap-y-2 text-left px-2 mb-2 md:mb-8" data-id="element-13">
              {['24 sesiones paso a paso', 'Fichas listas para imprimir', 'Registros clínicos', 'Sistema progresivo', 'Intervención en TDAH (+120 fichas)', 'Intervención en Dislexia (72 act.)', 'Intervención en TEA', 'Herramientas TCC aplicadas'].map((item, idx) => <div key={idx} className="flex items-center gap-1 md:gap-2" data-id="element-14">
                  <Check className="w-3 h-3 md:w-5 md:h-5 text-sky-600 flex-shrink-0" data-id="element-15" />
                  <span className="text-gray-700 text-[8px] md:text-sm leading-tight" data-id="element-16">
                    {item}
                  </span>
                </div>)}
            </div>

            <a href="#pricing" className="inline-flex items-center justify-center bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold text-[11px] md:text-lg px-5 py-2.5 md:px-8 md:py-4 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-105 mb-1" data-id="element-17">
              👉 Ver opciones desde $17.990
              <ArrowRight className="ml-1 w-3 h-3 md:w-5 md:h-5" data-id="element-18" />
            </a>
          </div>
        </div>
      </header>

      {/* Pain Point Section */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-19">
        <div className="max-w-3xl mx-auto" data-id="element-20">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-21">
            Si sos psicóloga, probablemente esto te pasa…
          </h2>

          <div className="bg-gray-50 rounded-2xl p-6 md:p-8 border border-gray-100 mb-8" data-id="element-22">
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-23">
              Terminás una sesión. Respirás. Mirás el reloj.
            </p>
            <p className="text-gray-700 mb-4 leading-relaxed" data-id="element-24">
              Y te das cuenta de algo.
            </p>
            <p className="text-gray-800 font-medium mb-6 leading-relaxed" data-id="element-25">
              Tenés otro paciente en 10 minutos… y todavía no sabés bien qué vas
              a trabajar.
            </p>
            <p className="text-gray-600 mb-4" data-id="element-26">
              Entonces empieza lo de siempre:
            </p>
            <p className="text-gray-600 italic mb-6" data-id="element-27">
              Abrís la computadora. Buscás ejercicios. Adaptás algo rápido.
              Imprimís sobre la marcha.
            </p>
            <p className="text-gray-700 mb-6" data-id="element-28">
              Y entrás a la sesión con esa sensación incómoda de:
            </p>
            <p className="text-sky-700 font-bold text-lg text-center mb-6 italic" data-id="element-29">
              "Espero que esto funcione."
            </p>

            <div className="border-t border-gray-200 pt-6" data-id="element-30">
              <p className="text-gray-800 font-medium mb-2" data-id="element-31">
                El problema no es tu capacidad como profesional.
              </p>
              <p className="text-sky-600 font-semibold" data-id="element-32">
                El problema es que estás sosteniendo todo sin un sistema que te
                sostenga a vos.
              </p>
            </div>
          </div>

          <p className="text-center text-gray-700 mb-10" data-id="element-33">
            Y eso termina generando tres cosas que desgastan a muchísimas
            psicólogas:
          </p>

          <div className="space-y-6" data-id="element-34">
            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-red-100 shadow-sm" data-id="element-35">
              <div className="flex items-center gap-3 mb-4" data-id="element-36">
                <div className="bg-red-100 p-2 rounded-full" data-id="element-37">
                  <AlertCircle className="w-6 h-6 text-red-500" data-id="element-38" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-39">
                  1️⃣ Inseguridad en sesión
                </h3>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-40">
                Cuando cada sesión depende de improvisar materiales o
                ejercicios.
              </p>
              <p className="text-gray-700 mb-3" data-id="element-41">Te preguntás:</p>
              <ul className="space-y-2 mb-4 ml-4" data-id="element-42">
                <li className="text-gray-600 italic" data-id="element-43">
                  ¿Será lo mejor para este caso?
                </li>
                <li className="text-gray-600 italic" data-id="element-44">
                  ¿Estoy trabajando bien este proceso?
                </li>
                <li className="text-gray-600 italic" data-id="element-45">
                  ¿Estoy dejando algo importante afuera?
                </li>
              </ul>
              <p className="text-gray-700" data-id="element-46">
                No porque no sepas trabajar.
                <br data-id="element-47" />
                <span className="font-medium" data-id="element-48">
                  Sino porque tenés que diseñar todo desde cero cada semana.
                </span>
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-orange-100 shadow-sm" data-id="element-49">
              <div className="flex items-center gap-3 mb-4" data-id="element-50">
                <div className="bg-orange-100 p-2 rounded-full" data-id="element-51">
                  <TrendingDown className="w-6 h-6 text-orange-500" data-id="element-52" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-53">
                  2️⃣ Ingresos que no crecen como deberían
                </h3>
              </div>
              <p className="text-gray-600 mb-4" data-id="element-54">Cuando tu energía se va en:</p>
              <div className="grid grid-cols-2 gap-2 mb-4" data-id="element-55">
                {['buscar recursos', 'preparar sesiones', 'armar materiales', 'organizar seguimiento'].map((item, idx) => <span key={idx} className="text-gray-600 text-sm" data-id="element-56">
                    • {item}
                  </span>)}
              </div>
              <p className="text-gray-700 mb-3" data-id="element-57">
                terminás teniendo menos tiempo para crecer profesionalmente.
              </p>
              <p className="text-gray-600 mb-2" data-id="element-58">Menos energía para:</p>
              <div className="space-y-1 mb-4" data-id="element-59">
                {['tomar más pacientes', 'mejorar tu práctica', 'desarrollar nuevas áreas'].map((item, idx) => <p key={idx} className="text-gray-600 text-sm" data-id="element-60">
                    • {item}
                  </p>)}
              </div>
              <p className="text-gray-700 font-medium" data-id="element-61">
                Y tu trabajo empieza a sentirse más pesado de lo que debería.
              </p>
            </div>

            <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-sky-100 shadow-sm" data-id="element-62">
              <div className="flex items-center gap-3 mb-4" data-id="element-63">
                <div className="bg-sky-100 p-2 rounded-full" data-id="element-64">
                  <BrainCog className="w-6 h-6 text-sky-500" data-id="element-65" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900" data-id="element-66">
                  3️⃣ Estrés mental constante
                </h3>
              </div>
              <p className="text-gray-700 mb-3" data-id="element-67">La cabeza no se apaga.</p>
              <p className="text-gray-600 mb-3" data-id="element-68">
                Terminás el día y seguís pensando:
              </p>
              <div className="space-y-1 mb-4" data-id="element-69">
                {['sesiones de mañana', 'ejercicios que faltan', 'materiales que hay que preparar'].map((item, idx) => <p key={idx} className="text-gray-600 text-sm" data-id="element-70">
                    • {item}
                  </p>)}
              </div>
              <p className="text-gray-700 font-medium" data-id="element-71">
                Porque cada semana implica volver a inventar todo otra vez.
              </p>
            </div>
          </div>

          <div className="mt-10 text-center" data-id="element-72">
            <p className="text-gray-700 text-lg mb-2" data-id="element-73">La realidad es esta:</p>
            <p className="text-gray-800 font-medium text-lg" data-id="element-74">
              Las psicólogas no se cansan de acompañar pacientes.
            </p>
            <p className="text-sky-600 font-bold text-lg" data-id="element-75">
              Se cansan de tener que improvisar todo solas.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-12 md:py-16 px-4 bg-gradient-to-b from-sky-50 to-white" data-id="element-76">
        <div className="max-w-3xl mx-auto text-center" data-id="element-77">
          <span className="text-sky-600 font-bold text-sm uppercase tracking-wider" data-id="element-78">
            LA SOLUCIÓN
          </span>
          <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mt-2 mb-4" data-id="element-79">
            MEGA PACK TERAPÉUTICO™
          </h2>
          <p className="text-lg text-gray-600 mb-8" data-id="element-80">
            Un sistema de trabajo pensado para psicólogas que trabajan en
            consultorio real.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-81">Todo el material ya está:</p>
          <div className="flex flex-wrap justify-center gap-3 mb-8" data-id="element-82">
            {['organizado', 'estructurado', 'listo para aplicar en sesión'].map((item, idx) => <span key={idx} className="bg-sky-100 text-sky-700 font-medium px-4 py-2 rounded-full text-sm" data-id="element-83">
                  ✔ {item}
                </span>)}
          </div>
          <p className="text-gray-700 mb-2" data-id="element-84">Solo tenés que:</p>
          <p className="text-xl md:text-2xl font-bold text-gray-900 mb-8" data-id="element-85">
            Descargar. Imprimir. Aplicar.
          </p>
        </div>
      </section>

      {/* 24 Sessions Detail */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-86">
        <div className="max-w-3xl mx-auto" data-id="element-87">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-3" data-id="element-88">
            24 SESIONES COMPLETAS
          </h2>
          <p className="text-gray-600 text-center mb-8" data-id="element-89">
            Un sistema organizado para 6 meses de trabajo terapéutico.
          </p>
          <div className="bg-sky-50 rounded-2xl p-6 md:p-8 border-2 border-sky-200 mb-8" data-id="element-90">
            <p className="font-bold text-gray-900 mb-4" data-id="element-91">Cada sesión incluye:</p>
            <div className="grid md:grid-cols-2 gap-3" data-id="element-92">
              {['objetivo terapéutico', 'actividades estructuradas', 'hojas de trabajo', 'registro clínico', 'progresión del proceso'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-93">
                  <Check className="w-5 h-5 text-sky-600 flex-shrink-0" data-id="element-94" />
                  <span className="text-gray-700" data-id="element-95">{item}</span>
                </div>)}
            </div>
          </div>
          <p className="text-gray-700 mb-3" data-id="element-96">Esto te permite:</p>
          <div className="space-y-2 mb-8" data-id="element-97">
            {['entrar a sesión con claridad', 'sostener procesos con orden', 'trabajar con seguridad profesional'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-98">
                <ArrowRight className="w-4 h-4 text-sky-600 flex-shrink-0" data-id="element-99" />
                <span className="text-gray-700 font-medium" data-id="element-100">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* What You Get */}
      <section className="py-12 md:py-16 px-4 bg-gray-50" data-id="element-101">
        <div className="max-w-3xl mx-auto" data-id="element-102">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-103">
            QUÉ TE LLEVÁS HOY
          </h2>
          <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-sky-200 mb-6" data-id="element-104">
            <div className="flex items-center gap-3 mb-4" data-id="element-105">
              <div className="bg-sky-600 text-white p-2 rounded-lg" data-id="element-106">
                <Package className="w-6 h-6" data-id="element-107" />
              </div>
              <h3 className="font-bold text-lg text-gray-900" data-id="element-108">
                MEGA PACK TERAPÉUTICO™ (BASE)
              </h3>
            </div>
            <div className="space-y-2" data-id="element-109">
              {['24 sesiones completas paso a paso', 'hojas de trabajo imprimibles', 'protocolos clínicos', 'mini guías de intervención', 'sistema de seguimiento terapéutico'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-110">
                  <Check className="w-5 h-5 text-sky-600 flex-shrink-0" data-id="element-111" />
                  <span className="text-gray-700" data-id="element-112">{item}</span>
                </div>)}
            </div>
          </div>
          <p className="text-gray-700 mb-3 font-medium" data-id="element-113">
            Material listo para usar en:
          </p>
          <div className="flex flex-wrap gap-3 mb-8" data-id="element-114">
            {['consultorio privado', 'terapia online', 'sesiones individuales', 'talleres terapéuticos'].map((item, idx) => <span key={idx} className="bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-medium" data-id="element-115">
                ✅ {item}
              </span>)}
          </div>
        </div>
      </section>

      {/* Bonuses */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-116">
        <div className="max-w-4xl mx-auto" data-id="element-117">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-10" data-id="element-118">
            🎁 BONOS INCLUIDOS HOY
          </h2>
          <div className="grid md:grid-cols-3 gap-6" data-id="element-119">
            {[{
            title: 'Mapa Terapéutico',
            desc: 'Un mapa visual que organiza todo el proceso terapéutico.',
            items: ['ver el recorrido completo', 'estructurar fases', 'trabajar con claridad'],
            image: 'https://cdn.magicpatterns.com/uploads/vMxGLEQ7TZhtHThDLdqQZH/751e3a26-32ae-4a1b-9b56-857abd2404d8-removebg-preview.png'
          }, {
            title: 'Checklist de Inicio de Tratamiento',
            desc: 'Los pasos clave para iniciar procesos terapéuticos sin confusión.',
            items: ['organizar primeras sesiones', 'evitar olvidos importantes', 'generar adherencia en pacientes'],
            image: 'https://cdn.magicpatterns.com/uploads/obAEEpvd6vHozr1QqmwEX5/bd5c6092-88ab-489c-9236-46a018f51221-removebg-preview.png'
          }, {
            title: 'Kit de Mensajes (WhatsApp)',
            desc: '21 mensajes listos para usar entre sesiones.',
            items: ['mensajes anti ansiedad', 'recordatorios terapéuticos', 'refuerzo de proceso'],
            image: 'https://cdn.magicpatterns.com/uploads/sSPogfVhD5Rdym6Sndx6Q4/99c0d622-16f3-40ee-8dab-0de55f0d054d-removebg-preview.png'
          }].map((bonus, idx) => <div key={idx} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm" data-id="element-120">
                <div className="bg-gradient-to-br from-sky-50 to-sky-100 p-4 flex items-center justify-center" data-id="element-121">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-48 object-contain drop-shadow-lg" data-id="element-122" />
                </div>
                <div className="p-5" data-id="element-123">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-124">
                    🎁 {bonus.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-3" data-id="element-125">{bonus.desc}</p>
                  <ul className="space-y-1" data-id="element-126">
                    {bonus.items.map((item, i) => <li key={i} className="flex items-center gap-2 text-sm text-gray-700" data-id="element-127">
                        <Check className="w-4 h-4 text-green-500 flex-shrink-0" data-id="element-128" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Premium Bonuses */}
      <section className="py-12 md:py-16 px-4 bg-sky-50" data-id="element-129">
        <div className="max-w-4xl mx-auto" data-id="element-130">
          <div className="text-center mb-10" data-id="element-131">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4" data-id="element-132">
              PERO HOY HAY ALGO MÁS
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-133">
              Hay tres áreas clínicas que suelen consumir muchísimo tiempo de
              preparación:
            </p>
            <div className="flex flex-wrap justify-center gap-3 mt-4" data-id="element-134">
              <span className="bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-medium" data-id="element-135">
                1️⃣ TDAH
              </span>
              <span className="bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-medium" data-id="element-136">
                2️⃣ Dislexia
              </span>
              <span className="bg-sky-100 text-sky-700 px-4 py-2 rounded-full text-sm font-medium" data-id="element-137">
                3️⃣ Intervenciones TCC
              </span>
            </div>
          </div>
          <p className="text-center text-gray-600 mb-10" data-id="element-138">
            Por eso hoy incluimos{' '}
            <span className="text-sky-700 font-bold" data-id="element-139">
              3 sistemas completos adicionales.
            </span>
          </p>

          <div className="bg-white rounded-2xl p-6 mb-6 border-2 border-orange-200 shadow-sm" data-id="element-140">
            <div className="flex items-center gap-2 mb-4" data-id="element-141">
              <Flame className="w-6 h-6 text-orange-500" data-id="element-142" />
              <span className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-143">
                BONO PREMIUM #1
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-144">
              SISTEMA COMPLETO DE INTERVENCIÓN EN TDAH
            </h3>
            <div className="space-y-2 mb-4" data-id="element-145">
              {['24 sesiones estructuradas', 'banco de +120 fichas terapéuticas', 'registros clínicos', 'trabajo con familias', 'seguimiento del progreso'].map((item, idx) => <div key={idx} className="flex items-start gap-2 text-gray-700" data-id="element-146">
                  <Check className="w-4 h-4 text-green-500 mt-1 flex-shrink-0" data-id="element-147" />
                  <span data-id="element-148">{item}</span>
                </div>)}
            </div>
            <p className="text-gray-500 text-sm italic" data-id="element-149">
              Para cuando llega un caso de TDAH y necesitás estructura clara sin
              improvisar.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 mb-6 border-2 border-teal-200 shadow-sm" data-id="element-150">
            <div className="flex items-center gap-2 mb-4" data-id="element-151">
              <Flame className="w-6 h-6 text-teal-500" data-id="element-152" />
              <span className="bg-teal-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-153">
                BONO PREMIUM #2
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-154">
              SISTEMA DE INTERVENCIÓN EN DISLEXIA
            </h3>
            <div className="space-y-2 mb-4" data-id="element-155">
              {['72 actividades estructuradas', 'ejercicios de lengua y matemática', 'registro de progreso', 'seguimiento terapéutico', 'comunicación con familias'].map((item, idx) => <div key={idx} className="flex items-start gap-2 text-gray-700" data-id="element-156">
                  <Check className="w-4 h-4 text-green-500 mt-1 flex-shrink-0" data-id="element-157" />
                  <span data-id="element-158">{item}</span>
                </div>)}
            </div>
            <p className="text-gray-500 text-sm italic" data-id="element-159">
              Todo listo para trabajar sin tener que inventar actividades cada
              semana.
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 border-2 border-blue-200 shadow-sm" data-id="element-160">
            <div className="flex items-center gap-2 mb-4" data-id="element-161">
              <Flame className="w-6 h-6 text-blue-500" data-id="element-162" />
              <span className="bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-163">
                BONO PREMIUM #3
              </span>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-164">
              HERRAMIENTAS TCC LISTAS PARA SESIÓN
            </h3>
            <p className="text-gray-600 mb-4" data-id="element-165">
              Actividades terapéuticas organizadas por área:
            </p>
            <div className="grid grid-cols-3 gap-4 mb-4" data-id="element-166">
              <div className="bg-sky-50 rounded-xl p-4 text-center" data-id="element-167">
                <p className="text-2xl font-bold text-sky-700" data-id="element-168">9</p>
                <p className="text-xs text-gray-600" data-id="element-169">pensamientos</p>
              </div>
              <div className="bg-sky-50 rounded-xl p-4 text-center" data-id="element-170">
                <p className="text-2xl font-bold text-sky-700" data-id="element-171">16</p>
                <p className="text-xs text-gray-600" data-id="element-172">emociones</p>
              </div>
              <div className="bg-sky-50 rounded-xl p-4 text-center" data-id="element-173">
                <p className="text-2xl font-bold text-sky-700" data-id="element-174">6</p>
                <p className="text-xs text-gray-600" data-id="element-175">conducta</p>
              </div>
            </div>
            <p className="text-gray-500 text-sm italic" data-id="element-176">
              Para esos momentos en sesión donde necesitás una intervención
              clara inmediatamente.
            </p>
          </div>
        </div>
      </section>

      {/* Testimonios */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-177">
        <div className="max-w-4xl mx-auto" data-id="element-178">
          <h2 className="text-xl md:text-3xl font-bold text-gray-900 text-center mb-10" data-id="element-179">
            LO QUE DICEN COLEGAS QUE YA LO USAN
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-180">
            {[{
            text: 'Llegaba a las sesiones corriendo y sin tiempo. Con el Mega Pack tengo todo armado: ejercicios, protocolos e ideas claras. Ahora atiendo más tranquila y mis pacientes lo notan.',
            name: 'Carla M.',
            role: 'Psicóloga Clínica'
          }, {
            text: 'Las 24 sesiones listas me ahorraron horas cada semana. Por primera vez siento que tengo un sistema real y no estoy improvisando todo el tiempo.',
            name: 'Lucía R.',
            role: 'Terapia Cognitivo Conductual'
          }, {
            text: 'El material de TDAH me salvó. Llegó un caso complejo y ya tenía las fichas, los registros y la estructura lista. Pude enfocarme en el paciente, no en armar todo.',
            name: 'Sofía P.',
            role: 'Psicóloga Infantojuvenil'
          }, {
            text: 'Estaba agotada de buscar recursos en internet. Este pack tiene justo lo que necesito, con estética profesional. Vale cada centavo invertido.',
            name: 'María V.',
            role: 'Psicóloga de Adultos'
          }, {
            text: 'Lo que más me gustó es el sistema progresivo. No es un PDF suelto, es un sistema pensado para sostener procesos reales. Se nota que lo hicieron psicólogas.',
            name: 'Valentina G.',
            role: 'Psicóloga Clínica'
          }, {
            text: 'Las fichas de dislexia son increíbles. Antes perdía horas armando actividades. Ahora imprimo y listo. Mis pacientes avanzan más y yo trabajo con menos estrés.',
            name: 'Daniela S.',
            role: 'Neuropsicóloga'
          }].map((testimonial, idx) => <div key={idx} className="bg-sky-50 p-6 rounded-2xl border border-sky-100" data-id="element-181">
                <div className="flex items-center gap-1 mb-3" data-id="element-182">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-183" />)}
                </div>
                <p className="text-gray-700 mb-4 italic text-sm leading-relaxed" data-id="element-184">
                  "{testimonial.text}"
                </p>
                <div className="flex items-center gap-3" data-id="element-185">
                  <div className="w-10 h-10 rounded-full bg-sky-200 flex items-center justify-center text-sky-700 font-bold text-sm" data-id="element-186">
                    {testimonial.name[0]}
                  </div>
                  <div data-id="element-187">
                    <p className="font-bold text-gray-900 text-sm" data-id="element-188">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-189">{testimonial.role}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-12 md:py-16 px-4 bg-sky-50" data-id="element-190">
        <div className="max-w-2xl mx-auto" data-id="element-191">
          <p className="text-center text-slate-500 text-sm font-medium tracking-wider mb-4" data-id="element-192">
            ESTA OFERTA EXPIRA EN
          </p>
          <div className="flex justify-center mb-8" data-id="element-193">
            <div className="bg-white border border-gray-200 rounded-full px-6 py-3 flex items-center gap-3 shadow-sm" data-id="element-194">
              <Clock className="w-5 h-5 text-slate-600" data-id="element-195" />
              <span className="text-slate-600 text-sm" data-id="element-196">
                Esta oferta expira en:
              </span>
              <CountdownTimer initialMinutes={15} data-id="element-197" />
            </div>
          </div>

          <h2 className="text-2xl md:text-4xl font-extrabold text-slate-800 text-center mb-2" data-id="element-198">
            Elegí tu <span className="text-sky-600" data-id="element-199">MEGA PACK:</span>
          </h2>
          <p className="text-center text-gray-500 text-sm md:text-base mb-8" data-id="element-200">
            Todas las opciones incluyen los bonos profesionales
          </p>

          <div className="space-y-3 mb-8" data-id="element-201">
            {[{
            id: 'base',
            icon: '📦',
            title: 'MEGA PACK BASE',
            desc: 'Mega Pack Terapéutico + TDAH + Dislexia + 3 bonos',
            oldPrice: '$79.000',
            price: '$17.990',
            badge: null
          }, {
            id: 'completo',
            icon: '🏆',
            title: 'MEGA PACK + ACTIVIDADES COGNITIVAS',
            desc: 'Todo lo del Pack Base + 50 actividades cognitivas para adolescentes',
            oldPrice: '$99.000',
            price: '$21.990',
            badge: 'MÁS ELEGIDO'
          }, {
            id: 'cognitivas20',
            icon: '🧠',
            title: 'FICHAS COGNITIVAS 20-50 AÑOS + MEGA PACK BASE',
            desc: 'Fichas cognitivas para adultos jóvenes y de mediana edad',
            oldPrice: '$99.000',
            price: '$21.990',
            badge: null
          }, {
            id: 'cognitivas60',
            icon: '🔬',
            title: 'FICHAS EVALUACIÓN COGNITIVA 60-90 AÑOS + MEGA PACK BASE',
            desc: 'Evaluación cognitiva especializada para adultos mayores',
            oldPrice: '$99.000',
            price: '$21.990',
            badge: null
          }, {
            id: 'demencia',
            icon: '🩺',
            title: 'FICHAS DEMENCIA MODERADA 60-90 AÑOS + MEGA PACK BASE',
            desc: 'Intervención en demencia moderada para adultos mayores',
            oldPrice: '$99.000',
            price: '$21.990',
            badge: null
          }, {
            id: 'demencialeve',
            icon: '💙',
            title: 'FICHAS DEMENCIA LEVE 60-90 AÑOS + MEGA PACK BASE',
            desc: 'Fichas cognitivas para demencia leve en adultos mayores',
            oldPrice: '$99.000',
            price: '$21.990',
            badge: null
          }, {
            id: 'todo',
            icon: '⭐',
            title: 'PACK COMPLETO — TODO INCLUIDO',
            desc: 'Todos los packs y fichas cognitivas en un solo acceso',
            oldPrice: '$199.000',
            price: '$29.990',
            badge: 'MEJOR VALOR'
          }].map(option => <div key={option.id} onClick={() => setSelectedPlan(option.id as any)} className={`relative cursor-pointer rounded-2xl p-4 md:p-5 border-2 transition-all ${selectedPlan === option.id ? 'border-sky-500 bg-sky-50 shadow-md' : 'border-gray-200 bg-white hover:border-sky-300'}`} data-id="element-202">
                <div className="flex items-start gap-3" data-id="element-203">
                  <div className="mt-1 flex-shrink-0" data-id="element-204">
                    <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === option.id ? 'border-sky-500' : 'border-gray-300'}`} data-id="element-205">
                      {selectedPlan === option.id && <div className="w-2.5 h-2.5 rounded-full bg-sky-500" data-id="element-206" />}
                    </div>
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-207">
                    <div className="flex justify-between items-start gap-2" data-id="element-208">
                      <div className="flex-1 min-w-0" data-id="element-209">
                        <div className="flex items-center gap-1.5 flex-wrap mb-0.5" data-id="element-210">
                          <span className="text-base" data-id="element-211">{option.icon}</span>
                          <h3 className="font-bold text-slate-800 text-sm leading-tight" data-id="element-212">
                            {option.title}
                          </h3>
                        </div>
                        {option.badge && <span className="inline-flex items-center gap-1 bg-green-100 text-green-700 text-xs font-bold px-2 py-0.5 rounded-full mb-1" data-id="element-213">
                            <Star className="w-3 h-3 fill-green-700" data-id="element-214" />{' '}
                            {option.badge}
                          </span>}
                        <p className="text-gray-500 text-xs leading-snug" data-id="element-215">
                          {option.desc}
                        </p>
                      </div>
                      <div className="text-right flex-shrink-0" data-id="element-216">
                        <p className="text-gray-400 line-through text-xs" data-id="element-217">
                          {option.oldPrice}
                        </p>
                        <p className={`font-extrabold ${option.id === 'todo' ? 'text-xl text-sky-600' : 'text-lg text-slate-800'}`} data-id="element-218">
                          {option.price}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>

          <a href={checkoutMap[selectedPlan]} className="block w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold text-lg md:text-xl px-8 py-5 rounded-full shadow-xl transition-all hover:scale-105 text-center mb-4" data-id="element-219">
            {ctaTextMap[selectedPlan]}
          </a>

          <p className="text-center text-gray-500 text-sm mb-6" data-id="element-220">
            Podés cambiar de opción cuando quieras
          </p>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-500 mb-8" data-id="element-221">
            <span data-id="element-222">✔ pago único</span>
            <span data-id="element-223">✔ acceso inmediato</span>
            <span data-id="element-224">✔ descarga ilimitada</span>
            <span data-id="element-225">✔ sin suscripciones</span>
          </div>

          {/* Details Box */}
          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8" data-id="element-226">
            <p className="text-slate-500 text-sm font-bold tracking-wider mb-6 uppercase" data-id="element-227">
              {detailsMap[selectedPlan].title}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-228">
              {detailsMap[selectedPlan].items.map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-229">
                  <Check className="w-5 h-5 text-sky-500 mt-0.5 flex-shrink-0" data-id="element-230" />
                  <span className="text-gray-700 text-sm" data-id="element-231">{item}</span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-12 md:py-16 px-4 bg-white" data-id="element-232">
        <div className="max-w-2xl mx-auto text-center" data-id="element-233">
          <div className="bg-green-50 border-2 border-green-200 rounded-2xl p-8" data-id="element-234">
            <ShieldCheck className="w-16 h-16 text-green-600 mx-auto mb-4" data-id="element-235" />
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-236">
              GARANTÍA TOTAL 7 DÍAS
            </h2>
            <p className="text-gray-700 mb-4" data-id="element-237">
              Probá todo el material durante una semana.
            </p>
            <p className="text-gray-700 mb-2" data-id="element-238">Si no sentís:</p>
            <div className="space-y-2 mb-6 text-left max-w-sm mx-auto" data-id="element-239">
              {['más orden en tus sesiones', 'menos estrés preparando material', 'más seguridad profesional'].map((item, idx) => <div key={idx} className="flex items-center gap-2" data-id="element-240">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-241" />
                  <span className="text-gray-700" data-id="element-242">{item}</span>
                </div>)}
            </div>
            <p className="text-gray-800 font-bold" data-id="element-243">
              te devolvemos el 100% del dinero.
            </p>
            <p className="text-green-700 font-semibold mt-2" data-id="element-244">Sin preguntas.</p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm" data-id="element-245">
        <p className="mb-4" data-id="element-246">
          © 2024 PsicoRecursos. Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-4" data-id="element-247">
          <a href="#" className="hover:text-white" data-id="element-248">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white" data-id="element-249">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-white" data-id="element-250">
            Contacto
          </a>
        </div>
      </footer>
    </div>;
}